import { isNil } from "lodash/fp"
import { inspect } from "./inspect"
import { rsApiRequestForAd } from "../AdAdmin/functions"
import { format } from "date-fns/fp"
import log from "loglevel"

// const env = process.env['REACT_APP_ENV'] ?? 'dev'
// istanbul ignore next
log.setLevel((process.env['LOG_LEVEL'] as log.LogLevelDesc) ?? log.levels.DEBUG)

export const adUpload = async (file: File): Promise<boolean> => {
  const data = new TextDecoder().decode(await file.arrayBuffer())
  log.debug(`[functions.doUpload]`, data)
  const result = await rsApiRequestForAd(`/v1/admin/ad/upload/contracts`, 'POST', {}, { file: data })
  if (isNil(result) || result.status !== 200) {
    return false
  }
  console.log(`[functions.doUpload] ${inspect({ data: result.data })}`)
  return result.data.success
}

export const adDownload = async (
): Promise<string | undefined> => {
  const date = format('yyyy-MM')(new Date())
  log.debug(date)
  const result = await rsApiRequestForAd(`/v1/admin/ad/download/contracts`, 'GET', {}, {}, { date })
  if (isNil(result) || result.status !== 200 || isNil(result.data)) {
    return undefined
  }
  console.log(`[functions.doDownload] ${inspect({ result })}`)
  return result.data
}

export const adConfirmBankNumberUpload = async (file: File): Promise<boolean> => {
  const data = new TextDecoder().decode(await file.arrayBuffer())
  log.debug(`[functions.adConfirmBankNumberUpload]`, data)
  const result = await rsApiRequestForAd(`/v1/admin/ad/upload/confirm-banknumber`, 'POST', {}, { file: data })
  if (isNil(result) || result.status !== 200) {
    return false
  }
  console.log(`[functions.adConfirmBankNumberUpload] ${inspect({ data: result.data })}`)
  return result.data.success
}
